export default "__VITE_ASSET__BgVicVrT__"